import { render, staticRenderFns } from "./PreferencesCard.vue?vue&type=template&id=0c4b475b&scoped=true&"
import script from "./PreferencesCard.vue?vue&type=script&lang=js&"
export * from "./PreferencesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4b475b",
  null
  
)

export default component.exports